module.exports = __webpack_public_path__ + "static/media/bubbles5.454a441e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bubbles5.svg
// module id = 2505
// module chunks = 7